import { render, staticRenderFns } from "./CyberCrimeCenter.vue?vue&type=template&id=31aaa5c4&"
import script from "./CyberCrimeCenter.vue?vue&type=script&lang=js&"
export * from "./CyberCrimeCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports